import {DateTime} from "luxon";

export function isGeoAllZero(geo) {
    return Array.isArray(geo) && geo.every(val => val === 0);
}

export function dateFormat(date) {
    const dt = DateTime.fromISO(String(date), {zone: 'Europe/London'});
    if (!dt.isValid) return '';
    return `${dt.toFormat('dd/MM/yy')} (${dt.toFormat('ccc').slice(0, 2)})`;
}

export function getDatesBetween(startDate, endDate) {
    let start = DateTime.fromISO(String(startDate), {zone: 'Europe/London'}).startOf('day');
    let end = DateTime.fromISO(String(endDate), {zone: 'Europe/London'}).startOf('day');
    if (!start.isValid || !end.isValid || start > end) return [];

    const dates = [];
    while (start <= end) {
        dates.push(`${start.toFormat('dd/MM/yy')} (${start.toFormat('ccc').slice(0, 2)})`);
        start = start.plus({days: 1});
    }
    return dates;
}

export function capitalizeFirst(value) {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function isAdmin(){
    const me = this.$store.state.auth.me;
    return me.roles.includes('admin');
}

export function isGod(){
    const me = this.$store.state.auth.me;
    return me.roles.includes('admin');
}
export function isForeman(){
    const me = this.$store.state.auth.me;
    return me.roles.includes('foreman');
}

export function showAdminDetails(){
    const me = this.$store.state.auth.me;
    return me.roles.includes('foreman') || me.roles.includes('admin');
}